export const GET_LIST_PROMO_REQUEST = 'GET_LIST_PROMO_REQUEST'
export const GET_LIST_PROMO_SUCCESS = 'GET_LIST_PROMO_SUCCESS'
export const GET_LIST_PROMO_FAIL = 'GET_LIST_PROMO_FAIL'

export const DELETE_LIST_PROMO_REQUEST = 'DELETE_LIST_PROMO_REQUEST'
export const DELETE_LIST_PROMO_SUCCESS = 'DELETE_LIST_PROMO_SUCCESS'
export const DELETE_LIST_PROMO_FAIL = 'DELETE_LIST_PROMO_FAIL'

export const CREATE_PROMO_REQUEST = 'CREATE_PROMO_REQUEST'
export const CREATE_PROMO_SUCCESS = 'CREATE_PROMO_SUCCESS'
export const CREATE_PROMO_FAIL = 'CREATE_PROMO_FAIL'

export const GET_DETAIL_PROMO_REQUEST = 'GET_DETAIL_PROMO_REQUEST'
export const GET_DETAIL_PROMO_SUCCESS = 'GET_DETAIL_PROMO_SUCCESS'
export const GET_DETAIL_PROMO_FAIL = 'GET_DETAIL_PROMO_FAIL'

export const GET_LIST_EXPORT_PROMO_REQUEST = 'GET_LIST_EXPORT_PROMO_REQUEST'
export const GET_LIST_EXPORT_PROMO_SUCCESS = 'GET_LIST_EXPORT_PROMO_SUCCESS'
export const GET_LIST_EXPORT_PROMO_FAIL = 'GET_LIST_EXPORT_PROMO_FAIL'

export const DOWNLOAD_EXPORT_PROMO_REQUEST = 'DOWNLOAD_EXPORT_PROMO_REQUEST'
export const DOWNLOAD_EXPORT_PROMO_SUCCESS = 'DOWNLOAD_EXPORT_PROMO_SUCCESS'
export const DOWNLOAD_EXPORT_PROMO_FAIL = 'DOWNLOAD_EXPORT_PROMO_FAIL'

